<template>
    <div>
        <footer>
            <div class="footertop">
                <p>全国统一服务电话 : 400-829-2006</p>
            </div>
            <div class="footer">
                <!-- <div>
                    <router-link to="/company">
                        <img src="@/assets/img/logo.png">
                    </router-link>
            
                </div> -->
                <div>
                    <router-link to="/companyPage">
                        <img src="@/assets/img/logo.png">
                    </router-link>
                    <div>
                        <h3>友情链接</h3>
                        <ul>
                            <li>南京东迈电子科技有限公司：<a href="http://www.njdmetc.com">http://www.njdmetc.com</a></li>
                            <li>成都东迈电子科技有限公司：<a href="http://www.cddmetc.com">http://www.cddmetc.com</a></li>
                        </ul>
                    </div>
                </div>
                <div>
                    <h3>产品</h3>
                    <ul v-for="(productItem, index) in products" :key="index + 'product'">
                        <li @click="getInfo(productItem)" style="cursor: pointer;">{{productItem.name}}</li>
                    </ul>
                </div>
                <div>
                    <h3>联系我们</h3>
                    <ul>
                        <li>400-829-2006</li>
                        <li>25048129@qq.com</li>
                    </ul>
                </div>
            </div>
            <div class="footerbottom">
                <div>
                    <p>备案/许可证编号为:粤ICP备2025415804号</p>
                </div>
                <div>
                    <ul>
                        <li><router-link to='/salesGuarantee'>售后保障</router-link></li>
                        <li>
                            <router-link to="/company">关于东迈</router-link>
                        </li>
                        <li><router-link to="/contact">联系我们</router-link></li>
                    </ul>
                </div>
            </div>

        </footer>
    </div>
</template>

<script>
import  { products } from '@/view/products';
export default {
    name: 'FooterPage',
    data() {
        return {
            products
        }
    },

    mounted() {
        window.scrollTo(0, 0);
    },

    methods: {
        getInfo(val) {
            var rowData = val;
            this.$store.state.custom.productId = val.id
            sessionStorage.setItem("rowData", JSON.stringify(rowData));
            if (!this.$route.path.includes('productDetail')) {
                this.$router.push({ name: "ProductsDetail"});
            }
        }
    }
}
</script>

<style scoped>
footer {
    background-color: white;
}
.footertop {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 50px;
    width: 100%;
    height: 100px;
    background-color: #1f497d;
    color: #ffffff;
    font-size: 20px;
}
.footertop button {
    width: 260px;
    border: solid #ffffff 3px;
    line-height: 50px;
    margin-left: 50px;
    border-radius: 40px;
    background-color: #1f497d;
    color: #ffffff;
    font-size: 20px;
}
.footer {
    display: flex;
    justify-content: space-around;
    /* align-items: center; */
    font-size: 18px;
    /* background-color: black; */
    margin: 50px 50px 20px 50px;
    border-bottom: solid #8f8f8f 1px;
}
.footer h3 {
    color: #8f8f8f;
}
.footer div {
    text-align: left;
}
.footer ul {
    padding: 0;
    margin: 10px 0;
}
.footer li {
    list-style: none;
    line-height: 30px;
    color: #8f8f8f;
    font-size: 18px;
    line-height: 30px;
}
.footer a {
    text-decoration: none;
    color: #8f8f8f;
    text-align: left;
    font-size: 18px;
    line-height: 40px;
}
.footerbottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin:0 50px;
    padding-bottom:20px;
    color: #8f8f8f;
}
.footerbottom ul {
    width: 300px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.footerbottom li {
    list-style: none;
}
.footerbottom a {
    color: #8f8f8f;
    text-decoration: none;
}
</style>